export const GET_BILLING_INFO = 'AUTH/GET_BILLING_INFO';
export const GET_BILLING_INFO_PENDING = `${GET_BILLING_INFO}_PENDING`;
export const GET_BILLING_INFO_FULFILLED = `${GET_BILLING_INFO}_FULFILLED`;
export const GET_BILLING_INFO_REJECTED = `${GET_BILLING_INFO}_REJECTED`;

export const getBillingInfo = () => ({
  type: GET_BILLING_INFO,
});
